export var toEuroString = function toEuroString(amount) {
    return amount.toFixed(2).toString().replace(".", ",") + " €";
};
